import { render, staticRenderFns } from "./PreRegistration.vue?vue&type=template&id=3a0bc99f&scoped=true"
import script from "./PreRegistration.vue?vue&type=script&lang=js"
export * from "./PreRegistration.vue?vue&type=script&lang=js"
import style0 from "./PreRegistration.vue?vue&type=style&index=0&id=3a0bc99f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0bc99f",
  null
  
)

export default component.exports